import {
  ApplicationBodyContainer, 
  ApplicationBodyContent,
  DefaultTitle, 
  DefaultSubtitle,
  FormContainer,
  PolicyTypeContainer,
  PolicyTableHeader,
  PolicyTableContainer,
  PolicyTable,
  PolicyImageContainer,
  Link
} from '../../../components/application/defaultComponents'
import ApplicationPrebuiltFooter from '../../../components/application/PrebuiltBodyFooter'
import { policyTypesCoverage } from 'src/constants/application'
import { tlieSources } from 'src/constants/tlie'
import StepBullet from 'src/components/basic/StepBullet'
import Button from 'src/components/basic/Button'
import legaldocImg from 'src/assets/applicationFormsImgs/legal_doc.svg'
import { useApplication } from 'src/context/application'
import { useNavigate, useLocation } from 'react-router-dom'
import { PolicyTypeOptions } from 'src/dtos/applicationData'

const Type = () => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const { application, saveApplication } = useApplication()

  const reviewMode = search.includes('review')

  const reviewUrl = search.includes('firm') ? '/review/firm' : '/review/attorneys'

  const goBackButtonRoute = () => {
    if(application?.liabilitySection?.pastLiability) {
      const { hasMalpracticeClaim, hasMalpracticeBasis } = application.liabilitySection.pastLiability
      
      if(hasMalpracticeClaim || hasMalpracticeBasis) return '/insurance/claims'
    }
    return '/insurance/past-liability'
  }

  const handleSelectQuote = async (policyType: PolicyTypeOptions) => {
    try {
      await saveApplication({
        ...application,
        currentPage: window.location.pathname,
        quotesSection: {
          quotes: [
            {
              policyType
            }
          ]
        },
        stoppedAt: reviewMode ? reviewUrl : '/quote/select'
      })
      navigate({
        pathname: '/quote/select',
        search
      })
    } catch(_) {}
  }

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent width='80%'>
        <DefaultTitle>First, select your policy type.</DefaultTitle>
        <DefaultSubtitle>You can review the differences in the policies you qualify for below.</DefaultSubtitle>
        <PolicyTableContainer>
          <h6>POLICY TYPES</h6>
          <PolicyTableHeader>
            <tbody>
              <tr>
                <td>
                  <PolicyImageContainer>
                    <img src={legaldocImg} alt="Policy Types" />
                  </PolicyImageContainer>
                </td>
                <td>
                  <PolicyTypeContainer>
                    <h5>Essential Policy</h5>
                    <p>This is our standard policy. It has some limitations both on services and limits of liability.</p>
                    <Button onClick={() => handleSelectQuote('BASIC')}>Start Quote</Button>
                  </PolicyTypeContainer>
                </td>
                <td>
                  <PolicyTypeContainer>
                    <h5>Premier Policy</h5>
                    <p>This is our top policy offering. It has the most service offerings. See below for a comparison</p>
                    <Button onClick={() => handleSelectQuote('REGULAR')}>Start Quote</Button>
                  </PolicyTypeContainer>
                </td>
              </tr>
            </tbody>
          </PolicyTableHeader>
        </PolicyTableContainer>
        <FormContainer maxWidth='100%' style={{ marginTop: '50px' }}>
          <PolicyTableContainer>
            <h6>PRICING</h6>
            <PolicyTable>
              <tbody>
                <tr>
                  <td>Limits of Liability</td>
                  <td>$100,000 – $1,000,000</td>
                  <td>$100,000 – $10,000,000</td>
                </tr>
                <tr>
                  <td>Deductibles</td>
                  <td>$1,000</td>
                  <td>$1,000 – $1,000,000</td>
                </tr>
              </tbody>
            </PolicyTable>
          </PolicyTableContainer>
          <PolicyTableContainer>
            <h6>COVERAGE</h6>
            <PolicyTable>
              <tbody>
                {policyTypesCoverage.map((coverage, index) => (
                  <tr key={index}>
                    <td>{coverage.coverageName}</td>
                    <td>
                      <div className='coverage-included'>
                        {coverage.essential.isIncluded ? <StepBullet isComplete /> : null}
                        {coverage.essential.label}
                      </div>
                    </td>
                    <td>
                      <div className='coverage-included'>
                        {coverage.premier.isIncluded ? <StepBullet isComplete /> : null}
                        {coverage.premier.label}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </PolicyTable>
          </PolicyTableContainer>
          <PolicyTableContainer>
            <h6>POLICY DETAILS</h6>
            <PolicyTable>
              <tbody>
                <tr>
                  <td>Policy Details</td>
                  <td>
                    <Link
                      href={tlieSources.quotePolicyBasic}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Read Essential Policy [Full] Here
                    </Link>
                  </td>
                  <td>
                  <Link
                      href={tlieSources.quotePolicyRegular}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Premier Policy [Full] Here
                    </Link>
                  </td>
                </tr>
              </tbody>
            </PolicyTable>
          </PolicyTableContainer>
        </FormContainer>
      </ApplicationBodyContent>
      <ApplicationPrebuiltFooter
        goBackRoute={goBackButtonRoute()}
        updatedApplication={application}
      />
    </ApplicationBodyContainer>
  )
}

export default Type